export default __webpack_public_path__ + "e169e68e31f3f8c6e8b34cd2e965f150.svg";